export default {
  common: {},
  mapBuilder: {},
  customerDataAnalysis: {},
  repositoryMatching: {},
  srmListManagement: {},
  developmentResourcesManagement: {},
  membership: {},
  company: {},
  monitoring: {},
  partners: {},
  identification: {},
  communications: {},
  processSetup: {},
  integrationSET: {},
  repositoryManager: {},
};
